<template>
  <b-container fluid id="app" v-if="user_has_dashboard_permission">
    <b-row class="m-0">
      <b-col class="mt-2 mb-4 p-0">
        <b-row style="flex-flow: nowrap; height: 50px;" class="white-box align-items-center mr-2 ml-2 pl-3 pr-0">
          <img style="width: 30px" src="@/assets/shoppub_logo_v2.svg" alt="shoppub_logo">
          <v-select
            id="context-selector"
            class="context-selector"
            style="width: 100%;"
            :searchable="false"
            :clearable="false"
            v-model="selected"
            :options="options"
            @input="switchContext()"/>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-if="selected.code === 1" class="m-0">
      <b-col class="px-0">
        <period-filters style="justify-content: space-between;" class="m-0 pr-2 mb-4 pl-2"/>

        <period-cards/>

        <payments-info/>

        <shippings-cards/>

        <customer-profile/>

        <graphs/>

        <visiting-info v-if="!is_multi_site_manager" class="mb-2"/>
      </b-col>
    </b-row>
    <!-- fim dashboard por período -->

    <b-row v-if="selected.code === 2" class="m-0">
      <b-col class="px-0">
        <status-info/>
      </b-col>
    </b-row>
    <!-- fim pedidos por status -->

    <b-row v-if="selected.code === 3" class="m-0">
      <b-col class="px-0">
        <abc-filters class="mb-4"/>

        <abc-curve/>
      </b-col>
    </b-row>
    <!-- fim dashboard contexto curva abc -->

    <b-row v-if="selected.code === 4" class="m-0">
      <b-col class="px-0">
        <stock-filters class="mb-4"/>

        <stock-info/>
      </b-col>
    </b-row>
    <!-- fim dashboard de estoques -->

    <b-row v-if="selected.code === 5" class="m-0">
      <b-col class="px-0">
        <sales-products-filters class="mb-4"/>

        <sales-info class="mb-4"/>

        <products-info/>
      </b-col>
    </b-row>
    <!-- fim dashboard de estatísticas de vendas e fim dashboard de produtos mais vendidos -->

    <b-row v-if="selected.code === 6" class="m-0">
      <b-col class="px-0">
        <receipt-visits-conversion-graph/>
      </b-col>
    </b-row>
    <!-- fim dashboard receitas / visitas / taxa de conversão -->

    <b-row v-if="selected.code === 7" class="m-0">
      <b-col class="px-0">
        <cancelled-bars/>

        <methods-info/>
      </b-col>
    </b-row>
    <!-- fim dashboard pedidos cancelados -->

    <b-row v-if="selected.code === 8" class="m-0">
      <b-col class="px-0">
        <ticket-progression-graph class="mb-4"/>

        <ticket-progression-cards/>
      </b-col>
    </b-row>
    <!-- fim dashboard progressão de ticket médio -->

    <b-row v-if="selected.code === 9" class="m-0">
      <b-col class="px-0">
        <shipping-costs/>

      </b-col>
    </b-row>
    <!-- fim custos de frete -->

  </b-container>
  <b-container fluid v-else-if="period_context_loaded" class="mt-4 text-12 px-4">
    <b-row class="django-like-alert-info m-0">
      <b-col>
        <b-row class="text-18">
          <strong>Dashboard da loja</strong>
        </b-row>
        <b-row>
          O seu usuário não possui permissão para visualizar o dashboard do administrativo.
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import HighCharts from 'highcharts'
require('highcharts/modules/exporting')(HighCharts);
require('highcharts/modules/drilldown')(HighCharts);
require('highcharts/modules/pareto')(HighCharts);

// Configurações globais para o HighCharts ====================================
// https://api.highcharts.com/highcharts/
HighCharts.setOptions({
  global: {
    canvasToolsURL: '',
  },
  lang:{
    decimalPoint: ',',
    thousandsSep: '.',
    drillUpText: '◁ Voltar para {series.name}',
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
             "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
                  "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    weekdays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
    printChart: 'Imprimir gráfico',
    downloadCSV: 'Baixar CSV',
    downloadJPEG: 'Baixar imagem JPEG',
    downloadPDF: 'Baixar documento PDF',
    downloadPNG: 'Baixar imagem PNG',
    downloadSVG: 'Baixar imagem em vetor SVG',
    downloadXLS: 'Baixar XLS',
    resetZoom: 'Redefinir zoom'
  },
  colors: ['#7ABA1E', '#FF524F', '#FCBC2C', '#0BA7DA', '#888888', '#AD55EA'],
  exporting: {
    buttons: {
      contextButton: {
        menuItems: ["printChart", "separator", "downloadPNG",
                    "downloadJPEG", "downloadPDF", "downloadSVG"],
      }
    }
  },
  credits: {
    enabled: true,
    href: '',
    position: {
      align: 'right',
      verticalAlign: 'bottom',
      x: -10,
      y: -5
    },
    style: {"cursor": "normal", "color": "#999999", "fontSize": "10px"},
    text: 'Highcharts.com'
  },
  title: {
    style: { "color": "#666666", "font-family": "'Open Sans', sans-serif" }
  },
  tooltip: {
    style: { "color": "#666666", "font-family": "'Open Sans', sans-serif" }
  }
});

import 'vue-loading-overlay/dist/vue-loading.css';

import PeriodFilters from '@/components/period_context/Filters.vue'
import PeriodCards from '@/components/period_context/PeriodCards.vue'
import PaymentsInfo from '@/components/period_context/PaymentsInfo.vue'
import ShippingsCards from '@/components/period_context/ShippingsCards.vue'
import CustomerProfile from '@/components/period_context/CustomerProfile.vue'
import Graphs from '@/components/period_context/Graphs.vue'
import VisitingInfo from '@/components/period_context/VisitingInfo.vue'
import StatusInfo from '@/components/status_context/StatusInfo.vue'
import StockFilters from '@/components/stock/Filters.vue'
import StockInfo from '@/components/stock/StockInfo.vue'
import SalesProductsFilters from '@/components/sales_products/Filters.vue'
import SalesInfo from '@/components/sales_products/SalesInfo.vue'
import ProductsInfo from '@/components/sales_products/ProductsInfo.vue'
import ReceiptVisitsConversionGraph from '@/components/receipt_visits_conversion_graph/ReceiptVisitsConversionGraph.vue'
import CancelledBars from '@/components/cancelled_context/CancelledBars.vue'
import MethodsInfo from '@/components/cancelled_context/MethodsInfo.vue'
import TicketProgressionGraph from '@/components/ticket_progression/Graph.vue'
import TicketProgressionCards from '@/components/ticket_progression/Cards.vue'
import AbcFilters from '@/components/curve_abc_context/Filters.vue'
import AbcCurve from '@/components/curve_abc_context/AbcCurve.vue'
import ShippingCosts from '@/components/shipping_costs/ShippingCosts.vue'

// Adição de contextos ========================================================
const CONTEXTS = [
  'visão geral por período',
  'pedidos por status',
  'Curva ABC de vendas',
  'visão geral dos estoques',
  'estatísticas de vendas e 20 produtos mais vendidos',
  'receitas / visitas / taxa de conversão da(s) loja(s)',
  'porque minhas vendas são canceladas',
  'progressão de ticket médio real',
  'custos de frete',
]

function getOptions() {
  let arr = [];
  CONTEXTS.forEach(function (item, i) {
    arr.push({ code: i+1, label: item });
  })
  return arr;
}

export default {
  mounted() {
    this.$store.commit('requestPeriodContext');
  },
  data: () => ({
    selected: {
      code: 1,
      label: 'visão geral por período (Clique aqui)'
    },
    options: getOptions()
  }),
  name: 'App',
  components: {
    PeriodFilters,
    PeriodCards,
    PaymentsInfo,
    ShippingsCards,
    CustomerProfile,
    Graphs,
    VisitingInfo,
    StatusInfo,
    StockFilters,
    StockInfo,
    SalesProductsFilters,
    SalesInfo,
    ProductsInfo,
    ReceiptVisitsConversionGraph,
    CancelledBars,
    MethodsInfo,
    TicketProgressionGraph,
    TicketProgressionCards,
    AbcFilters,
    AbcCurve,
    ShippingCosts
  },
  computed: {
    is_multi_site_manager() { return this.$store.getters.is_multi_site_manager },
    isRequesting() { return this.$store.getters.isRequesting },
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    user_has_dashboard_permission() { return this.$store.getters.user_has_dashboard_permission },
    status_context_loaded() { return this.$store.getters.status_context_loaded },
    stock_context_loaded() { return this.$store.getters.stock_context_loaded },
    sales_products_context_loaded() { return this.$store.getters.sales_products_context_loaded },
    receipt_visits_conversion_context_loaded() { return this.$store.getters.receipt_visits_conversion_context_loaded },
    cancelled_context_loaded() { return this.$store.getters.cancelled_context_loaded },
    ticket_progression_context_loaded() { return this.$store.getters.ticket_progression_context_loaded },
    abc_curve_context_loaded() { return this.$store.getters.abc_curve_context_loaded },
    shipping_costs_context_loaded() { return this.$store.getters.shipping_costs_context_loaded }
  },
  methods: {
    switchContext() {
      let url;
      let period;
      if (this.user_has_dashboard_permission) {
        switch (this.selected.code) {
          case 1:
            if (!this.period_context_loaded)
              this.$store.commit('requestPeriodContext');
            return;  // Além de ser o inicial ele possui uma requisição diferente
          case 2:
            if (!this.status_context_loaded)
              url = 'order/dashboard/order_status_context/';
            break;
          case 3:
            if (!this.abc_curve_context_loaded) {
              url = 'order/dashboard/order_curve_abc_context/';
              period = 7;  // initial period
            }
            break;
          case 4:
            if (!this.stock_context_loaded)
              url = 'product/dashboard/product/';
            break;
          case 5:
            if (!this.sales_products_context_loaded)
              url = 'order/dashboard/order_sales_products_context/';
            break;
          case 6:
            if (!this.receipt_visits_conversion_context_loaded)
              url = 'order/dashboard/receipt_visits_conversion/';
            break;
          case 7:
            if (!this.cancelled_context_loaded)
              url = 'order/dashboard/order_cancelled_context/';
            break;
          case 8:
            if (!this.ticket_progression_context_loaded)
              url = 'order/dashboard/order_ticket_progression_context/';
            break;
          case 9:
            if (!this.shipping_costs_context_loaded)
              url = 'order/dashboard/shipping_costs_context/';
            break;
        }
        this.$store.commit('requestCommonContext', {
          'url': url, 'period': period
        });
      }
    }
  }
};
</script>

<style>
  .django-like-alert-info {
    color: #3a87ad;
    background-color: #d9edf7;
    padding: 14px 35px 14px 14px;
    margin-bottom: 18px;
    border: 1px solid #bce8f1;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
  }
</style>
